import React from 'react';
import ResultsTable from '../results/ResultsTable';
import ChartDisplayOptions from '../results/ChartDisplayOptions';
import DownloadButton from '../results/DownloadButton';
import { useCalculations } from '../../context/CalculationContext';
import { useScenarios } from '../../context/ScenarioContext';
import { useSettings } from '../../context/SettingsContext';
import SectionNavigation from '../common/SectionNavigation';

function TablesSection({ onNextSection, onPreviousSection, currentSectionIndex, sectionNames }) {
  const { calculationResults } = useCalculations();
  const { scenarios } = useScenarios();
  const { globalSettings, scenarioVisibility, visibilitySettings } = useSettings();

  return (
    <div className="tables-section" style={{ padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Detailed Tables</h2>
        <DownloadButton />
      </div>
      <ChartDisplayOptions />
      <ResultsTable 
        scenarioResults={calculationResults?.scenarioResults} 
        scenarios={scenarios} 
        globalSettings={globalSettings} 
        scenarioVisibility={scenarioVisibility}
        visibilitySettings={visibilitySettings} 
      />
      <SectionNavigation
        onNextSection={onNextSection}
        onPreviousSection={onPreviousSection}
        currentSectionIndex={currentSectionIndex}
        sectionNames={sectionNames}
      />
    </div>
  );
}

export default TablesSection;
